module.exports = __webpack_public_path__ + "media/images/basic_logos/delete-3d9489d19dbc8e3d831ae33ccacb8ff3.svg";